
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { initClient } from '../../../../api';
import { GroupSurveyExtension, SettingsApiControllerUIClient, VisitorManagementUiClient } from '../../../backend/backendapi';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { vSelectInModalWithPopper } from '../../../../util';

type DD = {
  label: string;
  group: GroupSurveyExtension;
};

@Component({
  components: { vSelect },
})
export default class GroupSurveyGroupSelector extends Vue {
  @Prop({ required: true })
  group!: GroupSurveyExtension | null;

  readonly groupsForVSelect: DD[] = [];
  readonly selectedGroups: GroupSurveyExtension[] = [];
  maxGroups = 1;

  private readonly settingsApi = initClient(SettingsApiControllerUIClient);
  private readonly visitorApi = initClient(VisitorManagementUiClient);

  vSelectInModalWithPopper = vSelectInModalWithPopper;

  async mounted(): Promise<void> {
    await this.reloadGroups();
    await this.reloadSettings();
  }

  async reloadGroups(): Promise<void> {
    let groups = await this.visitorApi.getVisitorGroups();
    const list = groups.map(g => ({ label: g.group.name, group: g }));
    this.groupsForVSelect.splice(0);
    this.groupsForVSelect.push(...list);
  }

  async reloadSettings(): Promise<void> {
    try {
      const maxGroups = await this.settingsApi.getSystemSetting('VisitorManagementSettings.AdvanceRegistrationSurveySelectionViaGroupsMaxGroups');
      if (typeof maxGroups.result === 'string' //will be {} if setting not present
          && maxGroups.result.match(/^\d+$/g)) {
        this.maxGroups = parseInt(maxGroups.result);
      }
    } catch (error) { //in case the setting does not exist
      console.error(error);
    }
  }

  @Watch('groupsForVSelect')
  onGroupsForVSelectChanged(): void {
    this.selectedGroups.splice(0);
  }

  @Watch('selectedGroups', { deep: true })
  onSelectedGroupsChanged(val: GroupSurveyExtension[]): GroupSurveyExtension[] {
    this.$emit('change', val);
    return val;
  }
}
